import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/dcm-2020/dcm-2020.github.io/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const Title = makeShortcode("Title");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Accordion mdxType="Accordion">
  <AccordionItem title="Dr. Fei Wang, Associate Professor at Weill Cornell Medicine, Cornell University, USA." mdxType="AccordionItem">
    <Title mdxType="Title">Title:</Title>
    <p>Rethinking of Deep Learning in Analyzing Electronic Health Records
    </p>
    <Title mdxType="Title">Homepage:</Title>
    <p>https://wcm-wanglab.github.io/index.html</p>
  </AccordionItem>
  <AccordionItem title="Dr. Shigeo Yamaguchi, Assistant Professor at School of Medicine, Keio University, Japan." mdxType="AccordionItem">
    <Title mdxType="Title">Title:</Title>
    <p>
    Bioinformatics analysis application “Socrates” can get over discordance between clinical expert and bioinformatician
    </p>
    <Title mdxType="Title">Abstract:</Title>
    <p>
    As comprehensive analysis has become the mainstream of genomic research, publicly available genomic data has been increasing. Publicly available genomic data is powerful tool for many researchers. However, we had to learn programming language and bioinformatics skill to handle with comprehensive genomic data. Learning these skills is difficult for usual biological researcher, especially for medical researcher, which causes dissociation between researchers and bioinformatician. To solve this problem, we created a new application named “Socrates”. Socrates is fully made-to-order software. Using Socrates, researcher can handle with genomic and clinical information without learning programing skill. Socrates can make medical researchers analyze publicly available data like TCGA, CCLE, GEO, Array Express, dbGap. 
    </p>
    <p>
    To date, studies using publicly available genomic data had weakness that researchers had to give up if there was no data that suits their purpose. To overcome this weakness, we are challenging to create new prediction methods using publicly data by machine learning. We call this system “virtual laboratory system”. The purpose of establishing “virtual laboratory system” is to predict future experimental results in computer system without wet laboratory work. 
    </p>
    <p>
    Combining with “Socrates” and “virtual laboratory system” could make many researchers dramatic cost and time savings without effort to learn difficult programing skill. Although we are now challenging to establish this system, we will present achievements so far in this conference.
    </p>
    <Title mdxType="Title">Short Biography:</Title>
    <Title mdxType="Title">Education:</Title>
    <p>April 2003 to March 2009 - M.D. Tohoku University School of Medicine</p>
    <p>April 2014 to March 2018 - Ph.D. Tohoku University School of Medicine, Miyagi, Japan</p>
    <Title mdxType="Title">Postgraduate Training:</Title>
    <p>April 2014 to March 2019 - Staff in Department of Medical Oncology, Juntendo University of Medicine, Tokyo, Japan</p>
    <p>April 2011 to March 2014 - Senior resident in Department of Medical Oncology, Tokyo Metropolitan Cancer and Infectious Diseases Center Komagome Hospital, Tokyo, Japan</p>
    <p>April 2009 to March 2011 - Junior resident, South Miyagi Medical Center, Miyagi, Japan</p>
    <Title mdxType="Title">Current Position:</Title>
    <p>Assistant Professor at School of Medicine, Keio University, Japan</p>
    <p>President of cBioinformatics</p>
    <Title mdxType="Title">License and Certification:</Title>
    <p>2009 - National Board of Medicine, Japanese Society of Internal Medicine</p>
    <p>2013 - Board Certified Surgeon (Japan Physic Society)</p>
    <p>2016 - General Clinical Oncologist by Japanese Board of Cancer Therapy</p>
    <p>2018 - Medical chemotherapy specialist by Japanese Society of Medical Oncology</p>
    <Title mdxType="Title">Professional Memberships:</Title>
    <p>Japanese Society of Internal Medicine</p>
    <p>The Japanese Breast Cancer Society</p>
    <p>Japanese Society of Medical Oncology</p>
    <p>Japan Society of Clinical Oncology</p>
    <p>American Society of Clinical Oncology</p>
    <p>European Society of Medical Oncology</p>
  </AccordionItem>
    </Accordion>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      